import { render, staticRenderFns } from "./MyContractList.vue?vue&type=template&id=8436874e&"
import script from "./MyContractList.vue?vue&type=script&lang=js&"
export * from "./MyContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports